var InFlight = InFlight || {};
InFlight.CMS = (function () {

    var api = {
        token: "MC5YaERIaHhVQUFDUUE5NUVj.cFFT77-977-9ZO-_ve-_vVbvv73vv73vv71kWkbvv70T77-9W1vvv71D77-977-9WQ0v77-9FB4KWA",
        endPoint: "https://fiscal.cdn.prismic.io/api/v2"
    };

    var getContact = function () {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseContact(response));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'contact_page')
            );
        }).then(function (response) {
            return parseContact(response);
        }, function (err) {
            return err;
        });
        return query;
    }

    var getFAQ = function () {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseFAQ(response));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'faq_page')
            );
        }).then(function (response) {
            return parseFAQ(response);
        }, function (err) {
            return err;
        });
        return query;
    }

    var getWorkCenterBtns = function () {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseWorkCenterBtns(response));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'work-center-buttons')
            );
        }).then(function (response) {
            return parseWorkCenterBtns(response);
        }, function (err) {
            return err;
        });

        return query;
    }

    var getSiteBanner = function () {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseSiteBanner(response));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'site_banner')
            );
        }).then(function (response) {
            return parseSiteBanner(response);
        }, function (err) {
            return err;
        });
        return query;
    }

    var getGenericPage = function (pageUID) {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseGenericPage(response, pageUID));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'generic_page')
            );
        }).then(function (response) {
            return parseGenericPage(response, pageUID);
        }, function (err) {
            return err;
        });
        return query;
    }

    function getSiteMaintenance() {
        var previewDocID = getParameterByName('preview', window.location.href);
        if (window.location.href.indexOf('maintenance.html') !== -1 && previewDocID) {
            return new Promise(function(resolve, _) {
                var response = getPageDataFromIF7(previewDocID);
                resolve(parseSiteMaintenance(response));
            });
        }

        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'site_maintenance')
            );
        }).then(function (response) {
            return parseSiteMaintenance(response);
        }, function (err) {
            return err;
        });
        return query;
    }

    function getParameterByName(name, url) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    function getPageDataFromIF7(docID) {
        var response;
        $.ajax({
            async: false,
            type: 'GET',
            url: '/preview/get/' + docID,
            success: function(data) {
                response = data;
            },
            error: function(data) {
                response = {};
            }
       });
       return response;
    }

    function parseContact(response) {
        if (response.results.length < 1) {
            return {};
        }
        var responseData = response.results[0].data;

        var pageDetails = {
            'page_title': PrismicDOM.RichText.asText(responseData.page_title, null, _htmlSerializer),
            'page_subtitle': PrismicDOM.RichText.asText(responseData.page_subtitle, null, _htmlSerializer),
            'body': []
        };
        responseData.body.forEach(function (section) {
            var paragraphs = [];
            section.items.forEach(function (paragraph) {
                paragraphs.push({
                    'paragraph_title': PrismicDOM.RichText.asText(paragraph.paragraph_title, null, _htmlSerializer),
                    'paragraph_subtitle': PrismicDOM.RichText.asText(paragraph.paragraph_subtitle, null, _htmlSerializer),
                    'paragraph_content': PrismicDOM.RichText.asHtml(paragraph.paragraph_content, null, _htmlSerializer)
                });
            });

            pageDetails.body.push({
                'section_title': PrismicDOM.RichText.asText(section.primary.section_title, null, _htmlSerializer),
                'section_subtitle': PrismicDOM.RichText.asHtml(section.primary.section_subtitle, null, _htmlSerializer),
                'section_footer': PrismicDOM.RichText.asHtml(section.primary.section_footer, null, _htmlSerializer),
                'paragraphs': paragraphs
            });
        });
        return pageDetails;
    }

    function parseFAQ(response) {
        if (response.results.length < 1) {
            return {};
        }
        var responseData = response.results[0].data;

        var pageDetails = {
            'page_title': PrismicDOM.RichText.asText(responseData.page_title, null, _htmlSerializer),
            'page_subtitle': PrismicDOM.RichText.asText(responseData.page_subtitle, null, _htmlSerializer),
            'page_footer': PrismicDOM.RichText.asHtml(responseData.page_footer, null, _htmlSerializer),
            'last_modified': response.results[0].last_publication_date,
            'body': []
        };
        responseData.body.forEach(function (section) {
            var questionAnswers = [];
            section.items.forEach(function (qa) {
                questionAnswers.push({
                    'question': PrismicDOM.RichText.asText(qa.question, null, _htmlSerializer),
                    'answer': PrismicDOM.RichText.asHtml(qa.answer, null, _htmlSerializer)
                });
            });

            pageDetails.body.push({
                'section_title': PrismicDOM.RichText.asText(section.primary.section_title, null, _htmlSerializer),
                'questionAnswers': questionAnswers
            });
        });
        return pageDetails;
    }

    function parseWorkCenterBtns(response) {
        var sections = [];
        response.results.forEach(function (section_raw) {
            var normalized = _normalizeBase(section_raw);
            var result = $.extend(normalized, {
                buttons: $.map(section_raw.data["buttons"], function (button) {
                    return {
                        content: PrismicDOM.RichText.asText(button.content, null, _htmlSerializer),
                        href: PrismicDOM.RichText.asText(button.href, null, _htmlSerializer),
                        iconClass: PrismicDOM.RichText.asText(button["icon-class"], null, _htmlSerializer)
                    }
                })
            });
            sections.push(result);
        })
        return sections;
    }

    function parseSiteBanner(response) {
        if ($.isEmptyObject(response) || response.results.length < 1) {
            return {};
        }
        var responseData = response.results[0].data;

        var siteBanner = {
            'banner_text': PrismicDOM.RichText.asHtml(responseData.banner_text, null, _htmlSerializer),
        };
        return siteBanner;
    }

    function parseGenericPage(response, pageUID) {
        if (response.results.length < 1) {
            return {};
        }

        for (var i = 0; i < response.results.length; i++) {
            if (response.results[i].uid === pageUID) {
                var responseData = response.results[i].data;
                var pageDetails = {
                    'page_title': PrismicDOM.RichText.asText(responseData.page_title, null, _htmlSerializer),
                    'page_subtitle': PrismicDOM.RichText.asText(responseData.page_subtitle, null, _htmlSerializer),
                    'body': []
                };
                responseData.body.forEach(function (section) {
                    if (section.slice_type === 'content') {
                        var paragraphs = [];
                        section.items.forEach(function (paragraph) {
                            var video_url = paragraph.video_url.url;
                            if (video_url) {
                                var v = getParameterByName('v', video_url);
                                video_url = 'https://www.youtube.com/embed/' + v + '?feature=oembed';
                            }
                            paragraphs.push({
                                'paragraph_title': PrismicDOM.RichText.asHtml(paragraph.paragraph_title, null, _htmlSerializer),
                                'paragraph_content': _cleanHtmlLinks(PrismicDOM.RichText.asHtml(paragraph.paragraph_content, null, _htmlSerializer)),
                                'video': video_url
                            });
                        });
        
                        pageDetails.body.push({
                            'type': section.slice_type,
                            'section_title': PrismicDOM.RichText.asText(section.primary.section_title, null, _htmlSerializer),
                            'paragraphs': paragraphs
                        });
                    }
                    else if (section.slice_type === 'button') {
                        pageDetails.body.push({
                            'type': section.slice_type,
                            'text': PrismicDOM.RichText.asText(section.primary.button_text, null, _htmlSerializer),
                            'href': PrismicDOM.RichText.asText(section.primary.href_link, null, _htmlSerializer),
                            'text_color': PrismicDOM.RichText.asText(section.primary.text_color, null, _htmlSerializer),
                        });
                    }
                });
                return pageDetails;
            }
        }
        return {};
    }

    function parseSiteMaintenance(response) {
        var sections = [];
        response.results.forEach(function (section_raw) {
            var normalized = _normalizeBase(section_raw);
            var result = $.extend(normalized, {
                title: PrismicDOM.RichText.asText(section_raw.data["title"]),
                description: PrismicDOM.RichText.asHtml(section_raw.data["description"], null, _htmlSerializer)
            });
            sections.push(result);
        })
        return sections;
    }

    var _cleanHtmlLinks = function (link) {
        // prismic prepends any relative link so this is to convert it back to a relative link
        // ie. '/pages/index.aspx' becomes 'https:///pages/index.aspx"
        return link.replace(new RegExp('https:///', 'g'), '/')
    }

    var _normalizeBase = function (item) {
        return {
            uid: item.uid,
            title: PrismicDOM.RichText.asText(item.data.title, null, _htmlSerializer),
            creation_date: item.first_publication_date,
            modified_date: item.last_publication_date
        }
    }

    var _htmlSerializer = function (type, element, content, children) {
        switch (type) {
            case PrismicDOM.RichText.Elements.image:
                return '<img src="' + element.url + '" alt="' + element.alt + '" class="img-responsive">';
            default:
                return null;
        }
    };

    return {
        getFAQ: getFAQ,
        getContact: getContact,
        getWorkCenterBtns: getWorkCenterBtns,
        getSiteBanner: getSiteBanner,
        getGenericPage: getGenericPage,
        getSiteMaintenance: getSiteMaintenance
    };
})();
